"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTouchDevice = function () {
    return "ontouchstart" in window || "onmsgesturechange" in window;
};
exports.isAudioContextSupported = function () {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return !!(window.AudioContext || window.webkitAudioContext);
};
